import React from "react";
import { useSelector } from "react-redux";
import useTranslation from "../../hooks/useTranslation";

const VideoCall = () => {
  const { t } = useTranslation();
  const { videoCallHistory } = useSelector((state) => state.videoCallHistory);

  return (
    <div style={{ padding: "16px", maxWidth: "600px", margin: "0 auto" }}>
      {videoCallHistory?.length > 0 ? (
        videoCallHistory.map((data, index) => (
          <div
            key={index}
            style={{
              background: "var(--mx-surface)",
              border: "1px solid var(--mx-border)",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "12px",
            }}
          >
            {/* Date Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
                paddingBottom: "8px",
                borderBottom: "1px solid var(--mx-border)",
              }}
            >
              <span style={{ color: "var(--mx-text-2)", fontSize: "14px" }}>{t("date")}</span>
              <span
                style={{
                  color: "var(--mx-text)",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {data?.date ? data?.date : "-"}
              </span>
            </div>

            {/* Duration Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ color: "var(--mx-text-2)", fontSize: "14px" }}>
               {t("duration_sec")}
              </span>
              <span
                style={{
                  color: "var(--mx-accent)",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                {data?.callDurationSeconds ? data?.callDurationSeconds : 0}
              </span>
            </div>
          </div>
        ))
      ) : (
       <div style={{ 
          textAlign: "center", 
          padding: "40px", 
          color: "var(--mx-text-2)",
          fontSize: "16px",
          background: "transparent",
          borderRadius: "12px",
          // border: "1px solid var(--mx-border)"
        }}>
          {t("no_data_found")}
        </div>
      )}
    </div>
  );
};

export default VideoCall;
